import API from '../../common/api';
import type { State } from '../reducers';
import { Action, AnyAction, Dispatch } from 'redux';
import { Api } from '../../common/model';
import { ThunkDispatch } from 'redux-thunk';

type AppThunkDispatch<A extends Action = AnyAction> = ThunkDispatch<State, unknown, A>;

export const FETCH_SITES: string = 'FETCH_SITES';
export const FETCH_SITES_SUCCESS: string = 'FETCH_SITES_SUCCESS';
export const ARRIVAL_SITES_FILTERED: string = 'ARRIVAL_SITES_FILTERED';

const fetchSitesSuccess = ({ sites, switches }: Api.Referential) => ({
  type: FETCH_SITES_SUCCESS,
  sites,
  switches,
});

const arrivalSitesFiltered = (sites: Array<Api.Site>) => ({
  type: ARRIVAL_SITES_FILTERED,
  sites,
});

export const filterArrivalSites = (departure?: string) => (dispatch: Dispatch, getState: () => State) => {
  const { sites, switches } = getState().sites;

  if (departure) {
    const existSwitchWith = (site: Api.Site) => {
      const siteSwitch = switches.find(s => s.from.toString() === departure && s.to.toString() === site.id.toString());
      return siteSwitch !== undefined;
    };

    const isDeparture = (site: Api.Site) => site.id.toString() === departure;

    // Filtering arrival sites based on departure and existing switches
    const arrivalSites = sites.filter(site => existSwitchWith(site) || isDeparture(site));

    dispatch(arrivalSitesFiltered(arrivalSites));
  } else {
    dispatch(arrivalSitesFiltered(sites));
  }
};

const filterArrivalSitesOnceFetched = () => (dispatch: AppThunkDispatch, getState: () => State) => {
  const {
    booking: { departure },
  } = getState();
  if (departure && departure.site) dispatch(filterArrivalSites(departure.site));
};

export const fetchSites = () => (dispatch: AppThunkDispatch, getState: () => State) => {
  const { isFetchingSites } = getState().sites;
  if (isFetchingSites) return;

  dispatch({ type: FETCH_SITES });

  API.getSites().then(res => {
    dispatch(fetchSitesSuccess(res));
    dispatch(filterArrivalSitesOnceFetched());
  });
};
